import {csrfToken} from './api';

const endpoint='/api/v1/internal/owned-workspace-setup';
const uuid=/^[a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/;
export type OwnedSetupInput={legal_name:string;display_name:string;idempotency_key:string;confirm_owned_company:true};
function committed(result:unknown):{display_name:string}{
  if(!result||typeof result!=='object')throw new Error('Setup result unconfirmed.');
  const value=result as Record<string,unknown>;
  if(typeof value.created!=='boolean'||value.setup_status!=='committed'||value.owned_operations_available!==true
    ||typeof value.organization_id!=='string'||!uuid.test(value.organization_id)||typeof value.membership_id!=='string'||!uuid.test(value.membership_id)
    ||value.organization_id===value.membership_id||typeof value.display_name!=='string'||!value.display_name.trim())throw new Error('Setup result unconfirmed.');
  return {display_name:value.display_name};
}
export async function readOwnedSetup(key:string):Promise<{display_name:string}|null>{
  if(!uuid.test(key))throw new Error('Invalid request reference.');
  const response=await fetch(`${endpoint}/status/${key}`,{credentials:'same-origin',headers:{Accept:'application/json'}});
  const body=await response.json();
  if(!response.ok)throw new Error('Setup status unconfirmed.');
  if(body?.setup?.setup_status==='not_started'||body?.setup?.setup_status==='indeterminate')return null;
  return committed(body?.setup);
}
export async function loadOwnedSetup():Promise<{method:'mfa'|'password';verified:boolean}>{
  const response=await fetch(endpoint,{credentials:'same-origin',headers:{Accept:'application/json'}});
  const body=await response.json();
  if(!response.ok||(body.verification_method!=='mfa'&&body.verification_method!=='password')||typeof body.verified!=='boolean')throw new Error('Setup unavailable.');
  return {method:body.verification_method,verified:body.verified};
}
export async function verifyOwnedSetup(password:string):Promise<void>{
  const response=await fetch('/api/v1/auth/password-step-up',{method:'POST',credentials:'same-origin',headers:{Accept:'application/json','Content-Type':'application/json','X-ProFenz-CSRF':csrfToken()},body:JSON.stringify({password})});
  const body=await response.json();
  if(!response.ok||body.verified!==true)throw new Error('Verification unavailable.');
}
export async function createOwnedSetup(input:OwnedSetupInput):Promise<{display_name:string}>{
  const response=await fetch(endpoint,{method:'POST',credentials:'same-origin',headers:{Accept:'application/json','Content-Type':'application/json','X-ProFenz-CSRF':csrfToken()},body:JSON.stringify(input)});
  const body=await response.json();const result=body?.setup;
  if(!response.ok)throw new Error('Setup result unconfirmed.');
  const value=committed(result);
  if(value.display_name!==input.display_name)throw new Error('Setup result mismatch.');
  return value;
}
